import { useSelector } from 'react-redux'

import type { Recipe, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { getRecipe } from 'selectors/menu-recipes/getRecipe'

/**
 * Returns the recipe that is offered in the currently selected menu (for a currently selected number of portions)
 */
export const useRecipe = (id: RecipeUUID | null): Recipe | null => useSelector(getRecipe(id))
